export const acceptedFileTypes = {
  images: '.jpg, .jpeg, .png, .gif, .bmp, .webp, .svg',
  documents: '.pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .odt',
  audio: '.mp3, .wav, .ogg, .aac, .m4a',
  video: '.mp4, .avi, .mov, .wmv, .mkv, .webm',
  archives: '.zip, .rar, .7z, .tar, .gz',
  code: '.html, .css, .js, .ts, .json, .xml, .csv, .md',
  all: '*/*',
  png: '.png',
  jpg: '.jpg',
  jpeg: '.jpeg',
  gif: '.gif',
  svg: '.svg',
  webp: '.webp',
  bmp: '.bmp',
  ico: '.ico',
  tif: '.tif',
  tiff: '.tiff',
  pdf: '.pdf',
  doc: '.doc',
  docx: '.docx',
  xls: '.xls',
  xlsx: '.xlsx',
  ppt: '.ppt',
  pptx: '.pptx',
  txt: '.txt',
  rtf: '.rtf',
  odt: '.odt',
  mp3: '.mp3',
  wav: '.wav',
  ogg: '.ogg',
  m4a: '.m4a',
  flac: '.flac',
  mp4: '.mp4',
  avi: '.avi',
  mov: '.mov',
  mkv: '.mkv',
  webm: '.webm',
  wmv: '.wmv',
  zip: '.zip',
  rar: '.rar',
  '7z': '.7z',
  tar: '.tar',
  gz: '.gz',
  json: '.json',
  csv: '.csv',
  xml: '.xml',
  html: '.html',
  js: '.js',
  ts: '.ts',
  css: '.css',
  md: '.md',
};

export type acceptedExtensionsType = keyof typeof acceptedFileTypes;
